// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3CAGk","container":"Loading_container__1-JUw","spin":"Loading_spin__39sNT"};